<template>
  <div id="app">
    <IndexPage />
  </div>
</template>
<script>
import IndexPage from './components/IndexPage.vue'

export default {
  name: 'App',
  components: {
    IndexPage
  }
}
</script>

<style>

</style>
